import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube, FaTelegramPlane } from 'react-icons/fa';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          
          {/* About Quickcrate Express */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://minimartke-products-upload.s3.us-east-1.amazonaws.com/product-images/e4dabde0-e9b7-4b2c-b397-247b659efc13.png" 
                alt="Quickcrate Express Logo"
                className="w-10 h-10 object-contain"
              />
              <h3 className="text-xl font-bold">Quickcrate Express</h3>
            </div>
            <p className="text-gray-300 leading-relaxed text-sm">
              Your trusted online marketplace for electronics, household items, and everything you need. 
              We deliver quality products at competitive prices with fast, reliable shipping across Kenya.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2 text-gray-300">
                <FiMapPin className="w-4 h-4 text-blue-400" />
                <span>Nairobi, Kenya</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300">
                <FiPhone className="w-4 h-4 text-blue-400" />
                <span>+254 720 463 710</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-300">
                <FiMail className="w-4 h-4 text-blue-400" />
                <span>support@quickcrate.co.ke</span>
              </div>
            </div>
          </div>

          {/* Useful Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold mb-6">Useful Links</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Home</Link></li>
              <li><Link to="/search" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Browse Products</Link></li>
              <li><Link to="/ProductPage" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">My Cart</Link></li>
              <li><Link to="/ReturnsAndOrdersPage" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">My Orders</Link></li>
              <li><Link to="/MainCheckout" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Checkout</Link></li>
              <li><Link to="/Settings/GeneralSettings" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Account Settings</Link></li>
              <li><Link to="/Orders/OrderTracking" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Track Order</Link></li>
            </ul>
          </div>

          {/* Need Help & Make Money */}
          <div className="space-y-4">
            {/* Need Help Section */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Need Help?</h3>
              <ul className="space-y-3 text-sm">
                <li><Link to="/Notifications/notifications" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Notifications</Link></li>
                <li><Link to="/Settings/AccountSection/AccountSection" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Account Support</Link></li>
                <li><Link to="/Orders/OrderDetails" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Order Details</Link></li>
                <li><Link to="/ReturnsAndOrdersPage" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Returns & Refunds</Link></li>
                <li><Link to="/Orders/OrderTracking" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Track Your Order</Link></li>
              </ul>
            </div>

            {/* Make Money Section */}
            <div className="pt-4 border-t border-gray-700">
              <h3 className="text-lg font-semibold mb-4">Business with Quickcrate</h3>
              <ul className="space-y-3 text-sm">
                <li><Link to="" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Merchant Dashboard</Link></li>
                <li><Link to="/Products/AddProducts" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Add Products</Link></li>
                <li><Link to="/Merchants/MaintainMerchants" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Manage Store</Link></li>
                <li><Link to="/Reports" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">Sales Reports</Link></li>
              </ul>
            </div>
          </div>

          {/* Join Us On & Payment Methods */}
          <div className="space-y-4">
            {/* Social Media Section */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Join Us On</h3>
              <div className="flex space-x-4 mb-6">
                <a href="https://facebook.com/quickcrateexpress" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-200">
                  <FaFacebookF className="w-4 h-4" />
                </a>
                <a href="https://twitter.com/quickcrateexpress" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-400 transition-colors duration-200">
                  <FaTwitter className="w-4 h-4" />
                </a>
                <a href="https://instagram.com/quickcrateexpress" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors duration-200">
                  <FaInstagram className="w-4 h-4" />
                </a>
                <a href="https://linkedin.com/company/quickcrateexpress" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors duration-200">
                  <FaLinkedinIn className="w-4 h-4" />
                </a>
                <a href="https://youtube.com/@quickcrateexpress" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors duration-200">
                  <FaYoutube className="w-4 h-4" />
                </a>
                <a href="https://t.me/quickcrateexpress" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors duration-200">
                  <FaTelegramPlane className="w-4 h-4" />
                </a>
              </div>
            </div>

            {/* Payment Methods */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Payment Methods</h3>
              <div className="grid grid-cols-3 gap-3">
                <div className="bg-gray-800 rounded-lg p-2 flex items-center justify-center hover:bg-gray-700 transition-colors duration-200">
                  <img src="/Images/Mpesa.jpeg" alt="M-Pesa" className="h-6 object-contain" />
                </div>
                <div className="bg-gray-800 rounded-lg p-2 flex items-center justify-center hover:bg-gray-700 transition-colors duration-200">
                  <img src="/Images/card-logo-compact._CB478583243_.gif" alt="Credit Cards" className="h-6 object-contain" />
                </div>
                <div className="bg-gray-800 rounded-lg p-2 flex items-center justify-center hover:bg-gray-700 transition-colors duration-200">
                  <span className="text-xs font-medium text-white">MASTERCARD</span>
                </div>
                <div className="bg-gray-800 rounded-lg p-2 flex items-center justify-center hover:bg-gray-700 transition-colors duration-200">
                  <span className="text-xs font-medium text-orange-400">AIRTEL</span>
                </div>
                <div className="bg-gray-800 rounded-lg p-2 flex items-center justify-center hover:bg-gray-700 transition-colors duration-200">
                  <span className="text-xs font-medium text-blue-400">PAYPAL</span>
                </div>
                <div className="bg-gray-800 rounded-lg p-2 flex items-center justify-center hover:bg-gray-700 transition-colors duration-200">
                  <span className="text-xs font-medium text-green-400">BANK</span>
                </div>
              </div>
            </div>

            {/* Partners */}
            <div className="pt-4 border-t border-gray-700">
              <h3 className="text-lg font-semibold mb-4">Partners</h3>
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-gray-800 rounded-lg p-2 flex items-center justify-center hover:bg-gray-700 transition-colors duration-200">
                  <span className="text-xs font-medium text-blue-400">DHL</span>
                </div>
                <div className="bg-gray-800 rounded-lg p-2 flex items-center justify-center hover:bg-gray-700 transition-colors duration-200">
                  <span className="text-xs font-medium text-green-400">SAFARICOM</span>
                </div>
                <div className="bg-gray-800 rounded-lg p-2 flex items-center justify-center hover:bg-gray-700 transition-colors duration-200">
                  <span className="text-xs font-medium text-orange-400">FedEx</span>
                </div>
                <div className="bg-gray-800 rounded-lg p-2 flex items-center justify-center hover:bg-gray-700 transition-colors duration-200">
                  <span className="text-xs font-medium text-purple-400">SENDY</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Signup */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="text-xl font-semibold mb-3">Stay Updated</h3>
            <p className="text-gray-300 text-sm mb-6">Subscribe to our newsletter for exclusive deals and latest updates</p>
            <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input 
                type="email" 
                placeholder="Enter your email address" 
                className="flex-1 px-4 py-3 rounded-lg bg-gray-800 text-white placeholder-gray-400 border border-gray-700 focus:border-blue-500 focus:outline-none"
              />
              <button className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors duration-200">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 text-sm text-gray-400">
              <p>&copy; 2025 Quickcrate Express. All rights reserved.</p>
              <div className="flex space-x-4">
                <Link to="/Settings/AccountSection/AccountSection" className="hover:text-blue-400 transition-colors duration-200">Privacy Policy</Link>
                <Link to="/Settings/GeneralSettings" className="hover:text-blue-400 transition-colors duration-200">Terms of Service</Link>
                <Link to="/Notifications/notifications" className="hover:text-blue-400 transition-colors duration-200">Preferences</Link>
              </div>
            </div>
            <div className="text-sm text-gray-400">
              <span>Made with ❤️ in Kenya</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;